import {authHeader} from '../_helpers'
import axios from 'axios'

export const serviceTrackingService = {
  approveServiceTracking,
  getAllServicesTrackings,
  getMyServicesTrackings,
  createServiceTracking,
  getServiceTracking,
  updateServiceTracking,
  deleteServiceTracking
}

function getAllServicesTrackings (page, size) {
  return axios.get(process.env.BASE_URL + '/api/tracking/searchAll?page=' + page + '&size=' + size, {headers: authHeader()})
}

function getMyServicesTrackings (page, size, approved) {
  return axios.get(process.env.BASE_URL + '/api/tracking/searchUser?page=' + page + '&size=' + size + '&approved=' + approved, {headers: authHeader()})
}

function createServiceTracking (serviceTracking) {
  return axios.post(process.env.BASE_URL + '/api/tracking', serviceTracking, {headers: authHeader()})
}

function getServiceTracking (serviceTrackingId) {
  return axios.get(process.env.BASE_URL + '/api/tracking/' + serviceTrackingId, {headers: authHeader()})
}

function updateServiceTracking (service) {
  return axios.put(process.env.BASE_URL + '/api/tracking/' + service.id, service, {headers: authHeader()})
}

function deleteServiceTracking (serviceTrackingId) {
  return axios.delete(process.env.BASE_URL + '/api/tracking/' + serviceTrackingId, {headers: authHeader()})
}

function approveServiceTracking (serviceTrackingId) {
  return axios.post(process.env.BASE_URL + '/api/tracking/' + serviceTrackingId + '/approve', null, {headers: authHeader()})
}



// WEBPACK FOOTER //
// ./src/_services/service-tracking-service.js